const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function parseIsoDate(value: string): Date | undefined {
  if (!ISO_DATE_PATTERN.test(value)) return undefined;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  const matches =
    date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  return matches ? date : undefined;
}

export function getAgeInYears(date: Date, today = new Date()) {
  let age = today.getFullYear() - date.getFullYear();
  const hadBirthday =
    today.getMonth() > date.getMonth() ||
    (today.getMonth() === date.getMonth() && today.getDate() >= date.getDate());
  if (!hadBirthday) age -= 1;
  return age;
}

export function isAgeWithin(
  value: string,
  range: { minAge?: number; maxAge?: number },
  today = new Date(),
) {
  const date = parseIsoDate(value);
  if (!date || date > today) return false;
  const age = getAgeInYears(date, today);
  if (range.minAge !== undefined && age < range.minAge) return false;
  if (range.maxAge !== undefined && age > range.maxAge) return false;
  return true;
}

const pad = (value: number) => String(value).padStart(2, '0');

const toIsoDate = (date: Date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const yearsAgo = (years: number, today: Date) =>
  new Date(today.getFullYear() - years, today.getMonth(), today.getDate());

/** Primer y último día que el selector deja elegir para cumplir la edad pedida. */
export function getDateBoundsForAge(range: { minAge?: number; maxAge?: number }, today = new Date()) {
  return {
    minDate: toIsoDate(yearsAgo(range.maxAge ?? 110, today)),
    maxDate: toIsoDate(yearsAgo(range.minAge ?? 0, today)),
  };
}
